
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alertAi-revendas",
      function () {
        return require("private-next-pages/alertAi-revendas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alertAi-revendas"])
      });
    }
  